/* eslint-disable */
<template>
  <div class="movies">

    <div class="lastTime">
      마지막 소음 정보<br>
      시간 : {{new Date(datas[datas.length-1].time)}}
      <br>소음 크기: {{datas[datas.length-1].sound}}
      <br>진동의 값: {{datas[datas.length-1].vibration}}
    </div>
    <div class="chartWrap">
      <canvas id="myChart" width="800" height="400"></canvas>
    </div>
    <div>
      <div class="lengthShow">
        소음 발생 수: {{datas.length}}
      </div>
      <div class="select-last">
        최근 {{selectState}}개를 차트로 불러왔습니다.
        <div class="show-button">
          <button type="button" name="button" @click="changeShow(30)">최근 30개</button>
        </div>
        <div class="show-button">
          <button type="button" name="button" @click="changeShow(60)">최근 60개</button>
        </div>
        <div class="show-button">
          <button type="button" name="button" @click="changeShow(90)">최근 90개</button>
        </div>
        <div class="show-button">
          입력: <input type="text" name="button" v-model = "selectState" @click="changeShow(selectState)" placeholder="보고싶은 개수를 입력하세요"></input>
        </div>
      </div>
      <div class="show-button">
        <button type="button" @click="changeState()">{{show? "데이터 감추기":"데이터 보이기"}}</button>
      </div>
    </div>

    <div class="show-data-wrap" v-if="show">
      <div class="show-data" :key="i" v-for="(data,i) in datas">
        소음 : {{data.sound}}<br> 시간: {{new Date(data.time)}}<br> 진동: {{data.vibration}}
      </div>
    </div>
    <!-- <button @click="drawChart" class ="test-button">생성</button> -->

  </div>
</template>

<script>
import firebase from '../Firebase'
export default {
  data () {
    return {
      datas: [],
      length: 0,
      lastData: Object,
      ref_realtime: firebase.database().ref('/noise/id/1/'),
      ref_data: firebase.database().ref('/noise/id/1/data'),
      sound: 0,
      vibration: 0,
      myChart: -1,
      show: true,
      selectState: 0,
    }
  },
  created () {
    firebase.database().ref('/noise/id/1/data/')
    .on('child_added',(el)=> {
      this.datas.push({'sound': el.child('sound').val(), 'time': el.child('time').val(), 'vibration': el.child('vib').val()})
      this.selectState = this.datas.length
      // this.drawChart();
    });
    console.log(this.datas);
    firebase.database().ref('/noise/id/1/realtime').on('child_changed', (el)=>{
      if(el.key == 'vibration'){
        this.vibration = el.node_.value_;
      }else{
        this.sound = el.node_.value_;
      }
    })

  },
  updated() {
      if(this.myChart == -1){
        this.drawChart()
      }else{
        this.myChart.destroy();
        if(this.datas.length < this.selectState){
          this.selectState = this.datas.length;
        }
        this.drawChart(this.selectState);
      }
  },
  mounted() {
    this.$nextTick( () =>
      this.drawChart(this.selectState)
    )
  },
  methods: {
    drawChart(el){
      //console.log(this.datas.map( el => { return {x: moment(el.date,'MMMM Do YYYY, h:mm:ss a').valueOf(), y: el.vib }}));
      var ctx = document.getElementById('myChart').getContext('2d');
      this.myChart = new Chart(ctx,{
         type: 'bar',
         data: {
            datasets: [{
               label: '진동 세기',
               yAxisID: 'A',
               data: this.datas.map( el => { return {x: el.time, y: el.vibration }}).slice(this.datas.length-el,this.datas.length),
               //data: this.datas.map( el => { return {x: moment(new Date(el.time),'MMMM Do YYYY, h:mm:ss a').valueOf(), y: el.vib }}).slice(this.datas.length - 30,this.datas.length -1 ),
               // type: 'bar',
               backgroundColor: 'rgba(192,192,0,0.5)',
               borderColor: 'rgb(210, 0, 72)',
               pointRadius: 0,
               fill: true,
               lineTension:  1,
               borderWidth: 1
            },
            {
              label: '소리',
              yAxisID: 'B',
              data: this.datas.map( el => { return {x: el.time, y: el.sound }}).slice(this.datas.length-el,this.datas.length),
              //data: this.datas.map( el => { return {x: moment(new Date(el.time),'MMMM Do YYYY, h:mm:ss a').valueOf(), y: el.sound }}).slice(this.datas.length - 30,this.datas.length -1 ),
              type: 'bar',
              backgroundColor: 'rgba(0,0,192,0.5)',
              borderColor: 'rgb(210, 221, 72)',
              pointRadius: 0,
              fill: true,
              lineTension: 0,
              borderWidth: 1
            }
          ]
         },
         options: {
           responsive: true,
            scales: {
              scaleUse2Y: true,
               xAxes: [{
                  type: 'time',
                  distribution: 'series',
                  ticks: {
                     source: 'data',
                     autoSkip: false,
                  }
               }],
               yAxes: [{
                  id: 'A',
                  type: 'linear',
                  position: 'left',
                },

                {
                  id: 'B',
                  type: 'linear',
                  position: 'right',
                }
              ]
            },
            tooltips: {
               intersect: false,
               mode: 'index',
               callbacks: {
                  label: function(tooltipItem, myData) {
                     var label = myData.datasets[tooltipItem.datasetIndex].label || '';
                     if (label) {
                        label += ': ';
                     }
                     label += parseFloat(tooltipItem.value).toFixed(2);
                     return label;
                  }
               }
            },
            annotation: {
              annotations: [{
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-0',
                value: 1000,
                borderColor: 'rgb(75, 192, 192)',
                borderWidth: 5,
                label: {
                  enabled: false,
                  content: 'Test label'
                }
              }]
            },
          }
      });

    },
    changeState() {
      this.show? this.show = false: this.show = true;
    },
    measure() {
      console.log("as")
      firebase.database().ref('/noise/id/1/check')
      .push({
        "time": new Date(),
      })
    },
    changeShow(el) {
      console.log(el);
      if(el <= this.datas.length){
          this.selectState = el;
      }else{
        this.selectState = this.datas.length;
        alert("데이터 수가 더 적어요!")
      }

    }
  },
}
</script>

<style scoped>
.lengthShow{
  width: 180px;
  height: 80px;
  background-color: #454545;
  border-radius: 3px;
  color: white;
  display: inline-block;
  padding: 30px 0 0 0;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.lastTime{
  width: 350px;
  height: 150px;
  background-color: #454545;
  border-radius: 3px;
  color: white;
  display: inline-block;
  padding: 30px 0 0 0;
  box-sizing: border-box;
}
.test-button{
  display: inline-block;
  width: 100px;
  height: 80px;
}
.show-data{
  width: 400px;
  border: 1px solid black;
  border-radius: 3px;
  padding: 5px 0;
  display: inline-block;
  margin-bottom: 4px;
}
.show-button{
  margin: 10px 0;
}
.show-button button, input{
  width: 200px;
  height: 30px;
  background-color: white;
  color: black;
  border: 1px solid black;
  border-radius: 2px;
}
.show-button input{
  width: 160px;
}
@media (max-width: 400px) {
  .show-data{
    width: 350px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue